<mat-select [tabIndex]="tabIndex" [formControl]="selectCtrl" [compareWith]="compareWith"
  (selectionChange)="onSelectionChange()">
  <mat-option *ngFor="let carryingFeature of carryingFeatures" [value]="carryingFeature">{{ ('CarryingFeature.' +
    carryingFeature.name) | translate }}</mat-option>
</mat-select>

<mat-progress-spinner *ngIf="loading === true" diameter="16" mode="indeterminate"></mat-progress-spinner>